import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/service/user.service';
import { UserModel } from 'src/app/model/user.model';
import { TaggedUserModel } from 'src/app/model/tagged-user.model';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';

@Component({
  selector: 'app-unidade-select',
  templateUrl: './unidade-select.component.html',
  styleUrls: ['./unidade-select.component.scss']
})
export class UnidadeSelectComponent extends ComponentBase implements OnInit {

  users: TaggedUserModel[]
  usersPromise: Promise<any>
  unidades: AttributeModel[];

  constructor(private userService: UserService) {
    super()
  }

  get placeholder(): string {
    let placeholderOpt = this.attribute.options.find(option => option.key.toLowerCase() == "placeholder");

    if(placeholderOpt) {
      return placeholderOpt.value
    }

    return ""
  }

  ngOnInit() {
    this.unidades = this.userService.getCurrentUserAttributes("Unidades")
                        .sort((a,b)=> a.value.localeCompare(b.value));

    if(this.attribute.value == "") {
      this.attribute.value == null
    }
  }

  changedSelect() {
    let events: DynamicEvent[] = []
    
    this.validate(events)

    events.push({ name: "autosave", data: "silently" })

    this.emitEvents(events)
  }

  private validate(events: DynamicEvent[]) {
    if (this.attribute.hasError && this.attribute.value) {
      this.attribute.hasError = false;
      events.push({ name: "validate" });
    }
  }
}
